// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8936) return "static/chunks/8936-099af0f52c6ce945.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6735":"a3eb23c166e5ee5a","9388":"90994b89001e154f"}[chunkId] + ".js";
};